import store from '@/store'

export default function (to, from, next) {
    if (store.get('auth/role') === 'admin') {
        return next()
    }

    return next({ name: 'dashboard', replace: true })
}
